module.exports = __webpack_public_path__ + "img/newsIndImg6.1f1e5bd5.png";